/* eslint-disable @typescript-eslint/no-explicit-any */
import { sendRequest } from './sendRequest';
import { debug } from './logger';
import { isBotUserAgent } from './browser';

export function processQueue(url: string) {
  return (item: any, done: any) => {
    if (isBotUserAgent()) {
      return done(null, {});
    }
    item.sentAtTimestamp = new Date().toISOString();
    sendRequest(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(item),
    })
      .then((res) => done(null, res))
      .catch((err) => {
        debug({
          err,
          methodName: 'sendRequest',
          eventType: item.eventType || 'queue',
        });
        done(err);
      });
  };
}
